module.exports = __webpack_public_path__ + "media/images/category/feature/coj_f/coj_f-3-f1cca454ed7f4659aaa2f7bb40e0ec84.jpg";